export class Event {
  id: number;
  name: string;
  intranet_id: number;
  matter_id: number | undefined;
  event_type_id: number;
  notes: string;
  start: any;
  end: any;
  rrule: string;
  created_at: string;
  updated_at: string;
  created_by: number;
  updated_by: number;
  reminder: number | undefined;
  is_active: boolean = true;
  address_id: number | undefined;
  matter_history_id: number;
  phone_contact_id: number;
  phone_number_id: number | undefined;
  initiates_phone_call: boolean;
  billing_id: number;
  private: boolean = false;
  position: number;
  matter_user_attendees: Array<any> = [];
  involvement_attendees: Array<any> = [];
  colors: Array<any> = [];
  address: string;
  address_name: string;
  all_day: boolean = false;
  created: string;
  matter_name: string;
  matter_number: string;
  phone: string;
  phone_contact: string;
  is_private: boolean = false;
  reschedule: any;
  updated: string;
  formatted_reminder: string;
  formatted_rrule: string;
  start_str: string;
  end_str: string;
  event_type_name: string;
  humanized_duration: string;
  event_title_date: string;
  full_address: string;
  start_date_struct: any;
  end_date_struct: any;
  start_date: any;
  end_date: any;
  intranet_attendee: boolean = false;
  reminder_required: boolean = false;
  reminder_duration: number = 5;
  reminder_duration_unit: number = 60;
  rrule_text: string;
  until_time: any;
  until_time_date: any;
  until_time_struct: any;
  repeats_forever: boolean = false;
  matter_user_attendee_ids: Array<number> = [];
  involvement_attendee_ids: Array<number> = [];
  s_offset: any;
  e_offset: any;
  u_offset: any;
  contact_id: number;
  reminder_id: number;
  reminder_delivery_methods: Array<string> = [];
  updated_by_person_name: string;
  updated_by_link: string;
  updated_by_color_code: string;
  created_by_person_name: string;
  created_by_link: string;
  created_by_color_code: string;
  phone_event: string;
}
